import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/shared/ui/tabs";
import type { FlatSection } from "../types";
import { FlatSectionDispatch } from "../FlatSectionDispatch";

interface SectionTabGroupProps {
  tabs: { label: string; sections: FlatSection[] }[];
}

export function SectionTabGroup({ tabs }: SectionTabGroupProps) {
  if (tabs.length === 0) return null;
  return (
    <div className="px-5 py-4">
      <Tabs defaultValue={tabs[0].label}>
        {/* The list scrolls horizontally instead of wrapping so 4-5 store-view
            tabs stay one row on tablet; w-max keeps the pill background hugging
            the triggers inside the scroll container. */}
        <div className="overflow-x-auto">
          <TabsList className="w-max bg-muted/40">
            {tabs.map((t) => (
              <TabsTrigger key={t.label} value={t.label} className="px-2.5">
                {t.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
        {tabs.map((t) => (
          <TabsContent key={t.label} value={t.label} className="space-y-3 pt-3">
            {t.sections.map((s, i) => (
              <FlatSectionDispatch key={i} section={s} />
            ))}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
